import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const headerStyles = xcss({
	color: 'color.text',
	fontWeight: 'font.weight.medium',
	padding: 'space.250',
});

export const RevertModalHeader = ({ children }) => (
	<Box as="h2" xcss={headerStyles}>
		{children}
	</Box>
);

const contributorListStyles = xcss({
	listStyle: 'none',
	paddingLeft: 'space.0',
	maxHeight: '160px',
	overflowY: 'auto',
});

export const RevertContributorsList = ({ children }) => (
	<Box as="ul" xcss={contributorListStyles} testId="editor-revert-dialog-contributors-list">
		{children}
	</Box>
);

const contributorListItemStyles = xcss({
	float: 'left',
	width: '50%',
});

export const RevertContributorsListItem = ({ key, children }) => (
	<Box as="li" xcss={contributorListItemStyles} key={key}>
		{children}
	</Box>
);

const avatarStyles = xcss({
	filter: 'grayscale(100%)',
	opacity: 0.7,
	display: 'table-cell',
	verticalAlign: 'middle',
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
	paddingLeft: 'space.0',
	paddingRight: 'space.0',
});

export const ContributorAvatar = ({ children }) => <Box xcss={avatarStyles}>{children}</Box>;

const avatarImgStyles = xcss({
	height: 'size.300',
	borderRadius: 'radius.small',
});

export const ContributorAvatarImg = ({ src, alt }) => (
	<Box as="img" xcss={avatarImgStyles} src={src} alt={alt} />
);

const detailStyles = xcss({
	display: 'table-cell',
	paddingTop: 'space.0',
	paddingBottom: 'space.0',
	paddingLeft: 'space.100',
	paddingRight: 'space.100',
});

export const ContributorDetail = ({ children }) => <Box xcss={detailStyles}>{children}</Box>;

const detailNameStyles = xcss({
	fontWeight: 'font.weight.bold',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	display: 'block',
	width: '200px',
	overflow: 'hidden',
});

export const ContributorDetailName = ({ children }) => (
	<Box as="p" xcss={detailNameStyles}>
		{children}
	</Box>
);

const contributorDetailLastModificationStyles = xcss({
	display: 'inline-block',
	margin: 'space.0',
	font: 'font.body',
	verticalAlign: 'bottom',
	filter: 'grayscale(100%)',
	opacity: 0.6,
});

export const ContributorDetailLastModification = ({ children }) => (
	<Box as="p" xcss={contributorDetailLastModificationStyles}>
		{children}
	</Box>
);

const linkActionsStyles = xcss({
	marginTop: 'space.100',
	marginBottom: 'space.100',
	marginLeft: 'space.0',
	marginRight: 'space.0',
});

export const RevertLinkActions = ({ children }) => (
	<Box xcss={linkActionsStyles} testId="editor-revert-dialog-link-actions">
		{children}
	</Box>
);
